<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="sidebar-content"
        data-sidebar="content"
        :class="
            cn(
                '[&::-webkit-scrollbar-thumb]:bg-primary/50 flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-x-hidden [&::-webkit-scrollbar]:w-2 group-data-[collapsible=icon]:[&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-white/10',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
